import { render } from "./HomeSettingsPage.vue?vue&type=template&id=379dc451&ts=true"
import script from "./HomeSettingsPage.vue?vue&type=script&lang=ts"
export * from "./HomeSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__